import Config from '@config';
import { initializeMeteringDevicesCommercialApi } from '@gasbi/shared/common/features/meteringDevicesCommercial';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const {
  meteringDevicesCommercialApi,
  useGetMeteringDevicesCommercialQuery,
  useGetMeteringDeviceCommercialByIdQuery,
  useCreateMeteringDeviceCommercialMutation,
  useUpdateMeteringDeviceCommercialByIdMutation,
  useDeleteMeteringDeviceCommercialByIdMutation,
  useGetViolationActMeteringDevicesCommercialQuery,
  useGetMeteringDevicesCommercialInfiniteQuery,
  useGetMeteringDeviceCommercialByIdStatusHistoryInfiniteQuery,
  useGetSealCreationMeteringDevicesCommercialInfiniteQuery,
  useGetCachedDevicesCommercialByIdSelector,
} = initializeMeteringDevicesCommercialApi(Config.VITE_API_URL, axiosBaseQuery);
